import type { ComponentType } from 'react';
import withAnalyticsEvents from '@atlaskit/analytics-next/withAnalyticsEvents';

export type Callbacks<Props> = Record<keyof Props, string>;

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const map = (props: Callbacks<any>, componentName: string): Record<string, any> =>
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	Object.keys(props).reduce<Record<string, any>>(
		(result, key) => ({
			// oxlint-disable-next-line oxc/no-accumulating-spread
			...result,
			[key]: { action: props[key], actionSubject: componentName },
		}),
		{},
	);

export const AnalyticsEventToProps =
	(
		componentName: string,
		// oxlint-disable-next-line @typescript-eslint/no-explicit-any
		eventActions: Callbacks<any>,
	) =>
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	(WrappedComponent: ComponentType<any>): ComponentType<any> =>
		withAnalyticsEvents(map(eventActions, componentName))(WrappedComponent);
